import { render, staticRenderFns } from "./AddPotentialCustomerDetails.vue?vue&type=template&id=7c5e8fda&scoped=true&"
import script from "./AddPotentialCustomerDetails.vue?vue&type=script&lang=js&"
export * from "./AddPotentialCustomerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5e8fda",
  null
  
)

export default component.exports